import _ from "lodash";
import axios from "axios";
import axiosFileupload from "axios-fileupload";
import {
  APP_API_KEY,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
  BASE_IMAGES_LOCAL_URL,
} from "Constants";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { isEmpty } from "ActionsSpeakers";
import { getHeaders } from "CommonUtils";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
  deleteBulkRequest,
} from "NetworkCall";
import { randomstring } from "randomstring-js";

export var DELETE_SPONSORS_SUCESS = "delete_sponsors_success";
export var DELETE_SPONSORS_ERROR = "delete_sponsors_error";
export var INSERT_SPONSORS = "insert_sponsors";
export var FETCH_ALL_SPONSORS = "fetch_all_sponsors";
export var FETCH_SPONSORS = "fetch_sponsors";
export var SPONSORS_CATEGORIES = "SPONSORS_CATEGORIES";
export var LOAD_EDIT_SPONSOR_DATA = "load_edit_sponsor_data";
export var OPEN_SPONSOR_MODAL = "open_sponsor_modal";
export var SPONSOR_SEARCH = "sponsor_search";
export var OPEN_MEMBERSHIP_MODAL = "OPEN_MEMBERSHIP_MODAL";
export var EDIT_SPONSOR_CATEGORY = "EDIT_SPONSOR_CATEGORY";
export var UPDATE_CATEGORY_BGCOLOR = "UPDATE_CATEGORY_BGCOLOR";
export var UPDATE_CATEGORY_TEXTCOLOR = "UPDATE_CATEGORY_TEXTCOLOR";
export var UPDATED_SPONSOR_IMAGE = "UPDATED_SPONSOR_IMAGE";
export var UPDATED_SPONSOR_BANNER = "UPDATED_SPONSOR_BANNER";
export var IMPORT_SPONSOR_MODAL = "IMPORT_SPONSOR_MODAL";
export var UPDATE_SPONSOR_FILES = "UPDATE_SPONSOR_FILES";
export var SPONSOR_FILES_CHANGED = "SPONSOR_FILES_CHANGED";
export var SPONSOR_WORKING_DYNAMIC_FORM = "SPONSOR_WORKING_DYNAMIC_FORM";
export var SPONSOR_COUNTING_NUMBERS = "SPONSOR_COUNTING_NUMBERS";

export function fetchAllSponsors(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_categoryid,appuser_by_sponsoridfk&include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    dispatch(fetchSponsorCategories(session));
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ALL_SPONSORS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchSponsors(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_categoryid,appuser_by_sponsoridfk&include_count=true&filter=eventid=${session.eventid}&order=featured%20DESC%2C%20createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    dispatch(fetchSponsorCategories(session));
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPONSORS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchSponsors_(session, search = "", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var searchQuery = `(name like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_categoryid,appuser_by_sponsoridfk&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    dispatch(fetchSponsorCategories(session));
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPONSORS,
          payload: { data: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function searchSponsors(session, search = "", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  return (dispatch) => {
    dispatch(fetchSponsorCategories(session));
    dispatch(
      searchSponsorCategories(session, search, (response) => {
        // fetching mambership search data if any, then searching in sponsor including categoryid

        var searchQuery = `(name CONTAINS ${search}) `;

        _.map(response.data, (obj) => {
          searchQuery += `OR (categoryid CONTAINS ${obj.id}) `;
        });

        var filter = encodeURI(
          `(${searchQuery}) AND (eventid=${session.eventid})`
        );
        var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_categoryid,appuser_by_sponsoridfk&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;
        getRequest(
          url,
          session,
          dispatch,
          (data) => {
            dispatch({
              type: FETCH_SPONSORS,
              payload: { data: data.resource, count: data.meta.count },
            });
          },
          (error) => {}
        );
      })
    );
  };
}

export function sortByName(session, sort = "az", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var filter = encodeURI(`(eventid=${session.eventid})`);

  let orderBy = `&order=createdon%20DESC`;
  if (sort == "az") {
    orderBy = `&order=name%20ASC`;
  }
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?related=membershiptype_by_categoryid,appuser_by_sponsoridfk&include_count=true&filter=(${filter})${orderBy}${offSetQuery}`;

  return (dispatch) => {
    dispatch(fetchSponsorCategories(session));
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPONSORS,
          payload: { data: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function searchSponsorCategories(session, search = "", callback) {
  var searchQuery = `(membershiptitle CONTAINS ${search})`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/membershiptype?filter=${filter}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        var categories = _.sortBy(data.resource, [
          function (o) {
            return o.priorityindex;
          },
        ]);
        callback({ success: 1, data: categories });
      },
      (error) => {}
    );
  };
}

export function fetchSponsorCategories(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/membershiptype?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        var categories = _.sortBy(data.resource, [
          function (o) {
            return o.priorityindex;
          },
        ]);
        dispatch({ type: SPONSORS_CATEGORIES, payload: { data: categories } });
      },
      (error) => {}
    );
  };
}

export function deleteSponsor(session, sponsorid, callback) {
  return (dispatch) => {
    var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor/${sponsorid}`;
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        // dispatch(fetchSponsors(session));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteAssociatedAppuser(session, id, callback) {
  var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(sponsoridfk=${id})`;

  return (dispatch) => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function isimportant(session, sponsor, value, callback) {
  let body = { featured: value };
  let data = { resource: body };
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (sponsorid=${sponsor.sponsorid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
        // dispatch(fetchSponsors(session));
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function loadSponsorData(sponsor) {
  return {
    type: LOAD_EDIT_SPONSOR_DATA,
    payload: sponsor,
  };
}

export function openSponsorModal(option) {
  return {
    type: OPEN_SPONSOR_MODAL,
    payload: option,
  };
}

export function updateSponsorImage(image) {
  return {
    type: UPDATED_SPONSOR_IMAGE,
    payload: image,
  };
}

export function updateSponsorBanner(image) {
  return {
    type: UPDATED_SPONSOR_BANNER,
    payload: image,
  };
}

export function openMembershipModal(option) {
  return {
    type: OPEN_MEMBERSHIP_MODAL,
    payload: option,
  };
}

export function editSponsorCategory(option) {
  return {
    type: EDIT_SPONSOR_CATEGORY,
    payload: option,
  };
}

export function updateSponsorCategory(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/membershiptype`;

  var json = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      // dispatch(fetchSponsorCategories(session));
      // dispatch(fetchSponsors(session));
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function deleteSponsorCategory(session, categoryid, callback) {
  var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/membershiptype/${categoryid}`;
  return (dispatch) => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        // dispatch(fetchSponsorCategories(session));
        // dispatch(fetchSponsors(session));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function addSponsorCategory(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/membershiptype`;

  var json = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      // dispatch(fetchSponsorCategories(session));
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    postRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function workingDynamicForm(data) {
  return (dispatch) => {
    dispatch({ type: SPONSOR_WORKING_DYNAMIC_FORM, payload: data });
  };
}

// Below code is comented by vinay on 19-11-2020 as now we are not uploading the file separately and banner is added
// export function insertSponsor(session,values,sponsor,imagedata,filechanged,uploadFiles,callback){
//   var eventid = session.eventid;
//   values = {...values,eventid};

//   return (dispatch)=>{
//     if(imagedata && filechanged.ischanged) {

//       _uploadProfile(session, imagedata, dispatch, (profile) => {
//         if(profile.success) {
//           _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
//             values = {
//               ...values,
//               logoimgpath: profile.data.path,
//               logothumbimgpath: profile.data.path,
//               file1: attachments[0].file,
//               file2: attachments[1].file,
//               file3: attachments[2].file,
//               file4: attachments[3].file,
//               file5: attachments[4].file,
//             };
//             _createUpdateSponsor(session,values,sponsor,dispatch,(feedback)=>{
//               if(feedback.success) {
//                 dispatch(_updteAppuserSponsors(session,values,sponsor,feedback.sponsorid,callback));
//               }
//               else {
//                 callback({error:0, data:feedback.data});
//               }
//             });
//             // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
//           });
//         }
//         else {
//           callback({error:2, data:profile.data.message});
//         }
//       });
//     }
//     else if(imagedata && !filechanged.ischanged) {

//       _uploadProfile(session, imagedata, dispatch, (profile) => {
//         if(profile.success) {
//           values = {...values, logoimgpath: profile.data.path, logothumbimgpath: profile.data.path};
//           _createUpdateSponsor(session,values,sponsor,dispatch,(feedback)=>{
//             if(feedback.success) {
//               dispatch(_updteAppuserSponsors(session,values,sponsor,feedback.sponsorid,callback));
//             }
//             else {
//               callback({error:0, data:feedback.data});
//             }
//           });
//           // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
//         }
//         else {
//           callback({error:2, data:profile.data.message});
//         }
//       });
//     }
//     else if(!imagedata && filechanged.ischanged) {

//       _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
//         values = {
//           ...values,
//           file1: attachments[0].file,
//           file2: attachments[1].file,
//           file3: attachments[2].file,
//           file4: attachments[3].file,
//           file5: attachments[4].file,
//         };
//         _createUpdateSponsor(session,values,sponsor,dispatch,(feedback)=>{
//           if(feedback.success) {
//             dispatch(_updteAppuserSponsors(session,values,sponsor,feedback.sponsorid,callback));
//           }
//           else {
//             callback({error:0, data:feedback.data});
//           }
//         });
//         // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
//       });
//     }
//     else {

//       values = {...values};
//       _createUpdateSponsor(session,values,sponsor,dispatch,(feedback)=>{
//         if(feedback.success) {
//           dispatch(_updteAppuserSponsors(session,values,sponsor,feedback.sponsorid,callback));
//         }
//         else {
//           callback({error:0, data:feedback.data});
//         }
//       });
//       // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
//     }
//   }
// }

export function insertSponsor(
  session,
  values,
  sponsor,
  imagedata,
  bannerdata,
  filechanged,
  sponsorWorkingDynamicForm,
  callback
) {
  var eventid = session.eventid;
  values = { ...values, eventid };
  // debugger;

  // Remove blank values from all file fields fileArray
  if (sponsorWorkingDynamicForm && sponsorWorkingDynamicForm.workingEventForm) {
    _.map(sponsorWorkingDynamicForm.workingEventForm, (obj) => {
      if (obj.key === "file" && obj.fileArray && obj.fileArray.length > 0) {
        var newFileArray = _.filter(obj.fileArray, (o) => {
          return o != "";
        });
        obj.fileArray = newFileArray;
      }
    });
  }

  // Fetch only files field
  var otherFilesData = _.filter(
    sponsorWorkingDynamicForm.workingEventForm,
    (file) => {
      return file.key === "file";
    }
  );

  // Fetch dynamic field responses
  var responsesArray = JSON.parse(values.responses);

  // debugger;
  return (dispatch) => {
    if (imagedata && bannerdata && filechanged.ischanged) {
      // debugger;
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              _uploadDynamicFormsFiles(
                session,
                otherFilesData,
                dispatch,
                (filesArray) => {
                  _.map(filesArray, (obj) => {
                    var check = _.filter(responsesArray, function (file) {
                      return file.name === obj.name;
                    });
                    check[0].value = obj.fileArray;
                  });

                  values = {
                    ...values,
                    logoimgpath: profile.data.path,
                    logothumbimgpath: profile.data.path,
                    bannerimage: banner.data.path,
                    responses: JSON.stringify(responsesArray),
                  };

                  _createUpdateSponsor(
                    session,
                    values,
                    sponsor,
                    dispatch,
                    (feedback) => {
                      if (feedback.success) {
                        dispatch(
                          _updteAppuserSponsors(
                            session,
                            values,
                            sponsor,
                            feedback.sponsorid,
                            callback
                          )
                        );
                      } else {
                        callback({ error: 0, data: feedback.data });
                      }
                    }
                  );
                  // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
                }
              );
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (imagedata && bannerdata && !filechanged.ischanged) {
      // debugger;
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadBanner(session, bannerdata, dispatch, (banner) => {
            if (banner.success) {
              values = {
                ...values,
                logoimgpath: profile.data.path,
                logothumbimgpath: profile.data.path,
                bannerimage: banner.data.path,
              };
              _createUpdateSponsor(
                session,
                values,
                sponsor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    dispatch(
                      _updteAppuserSponsors(
                        session,
                        values,
                        sponsor,
                        feedback.sponsorid,
                        callback
                      )
                    );
                  } else {
                    callback({ error: 0, data: feedback.data });
                  }
                }
              );
              // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
            } else {
              callback({ error: 2, data: banner.data.message });
            }
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (imagedata && !bannerdata && filechanged.ischanged) {
      // debugger;
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              values = {
                ...values,
                logoimgpath: profile.data.path,
                logothumbimgpath: profile.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateSponsor(
                session,
                values,
                sponsor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    dispatch(
                      _updteAppuserSponsors(
                        session,
                        values,
                        sponsor,
                        feedback.sponsorid,
                        callback
                      )
                    );
                  } else {
                    callback({ error: 0, data: feedback.data });
                  }
                }
              );
              // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (!imagedata && bannerdata && filechanged.ischanged) {
      // debugger;
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          _uploadDynamicFormsFiles(
            session,
            otherFilesData,
            dispatch,
            (filesArray) => {
              _.map(filesArray, (obj) => {
                var check = _.filter(responsesArray, function (file) {
                  return file.name === obj.name;
                });
                check[0].value = obj.fileArray;
              });

              values = {
                ...values,
                bannerimage: banner.data.path,
                responses: JSON.stringify(responsesArray),
              };

              _createUpdateSponsor(
                session,
                values,
                sponsor,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    dispatch(
                      _updteAppuserSponsors(
                        session,
                        values,
                        sponsor,
                        feedback.sponsorid,
                        callback
                      )
                    );
                  } else {
                    callback({ error: 0, data: feedback.data });
                  }
                }
              );
              // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
            }
          );
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (imagedata && !bannerdata && !filechanged.ischanged) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          values = {
            ...values,
            logoimgpath: profile.data.path,
            logothumbimgpath: profile.data.path,
          };
          _createUpdateSponsor(
            session,
            values,
            sponsor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                dispatch(
                  _updteAppuserSponsors(
                    session,
                    values,
                    sponsor,
                    feedback.sponsorid,
                    callback
                  )
                );
              } else {
                callback({ error: 0, data: feedback.data });
              }
            }
          );
          // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (!imagedata && bannerdata && !filechanged.ischanged) {
      _uploadBanner(session, bannerdata, dispatch, (banner) => {
        if (banner.success) {
          values = {
            ...values,
            bannerimage: banner.data.path,
          };
          _createUpdateSponsor(
            session,
            values,
            sponsor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                dispatch(
                  _updteAppuserSponsors(
                    session,
                    values,
                    sponsor,
                    feedback.sponsorid,
                    callback
                  )
                );
              } else {
                callback({ error: 0, data: feedback.data });
              }
            }
          );
          // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
        } else {
          callback({ error: 2, data: banner.data.message });
        }
      });
    } else if (!imagedata && !bannerdata && filechanged.ischanged) {
      _uploadDynamicFormsFiles(
        session,
        otherFilesData,
        dispatch,
        (filesArray) => {
          _.map(filesArray, (obj) => {
            var check = _.filter(responsesArray, function (file) {
              return file.name === obj.name;
            });
            check[0].value = obj.fileArray;
          });

          values = {
            ...values,
            responses: JSON.stringify(responsesArray),
          };

          _createUpdateSponsor(
            session,
            values,
            sponsor,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                dispatch(
                  _updteAppuserSponsors(
                    session,
                    values,
                    sponsor,
                    feedback.sponsorid,
                    callback
                  )
                );
              } else {
                callback({ error: 0, data: feedback.data });
              }
            }
          );
          // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
        }
      );
    } else {
      values = { ...values };
      _createUpdateSponsor(session, values, sponsor, dispatch, (feedback) => {
        if (feedback.success) {
          dispatch(
            _updteAppuserSponsors(
              session,
              values,
              sponsor,
              feedback.sponsorid,
              callback
            )
          );
        } else {
          callback({ error: 0, data: feedback.data });
        }
      });
      // dispatch(_createUpdateSponsor(session,values,sponsor,callback));
    }
  };
}

export function _uploadProfile(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/sponsors/${randomstring(32)}.png`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadBanner(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/sponsors/banner/${randomstring(
    32
  )}.png`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.file;
        var name = item.filename;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileCustomName = name.substr(0, name.lastIndexOf("."));
          var fileType = name.split(".").pop();

          var filename = `eventify/${eventid}/files/sponsors/${fileCustomName}_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ ...uploadFiles });
  });
}

export function _uploadDynamicFormsFiles(
  session,
  otherFilesData,
  dispatch,
  callback
) {
  // uploadFiles
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(otherFilesData, (field, key) => {
    // Files field array
    var uploadFiles = field.fileArray;
    var fileCategory =
      field.name === "galleryimages"
        ? "galleryimages"
        : field.name === "galleryvideos"
        ? "galleryvideos"
        : field.name === "documents"
        ? "documents"
        : "otherfiles";
    _.map(uploadFiles, (item, index) => {
      if (item) {
        promiseArray.push(
          new Promise((resolve, reject) => {
            var file = item.file;
            var name = item.filename;
            var n = file.search(";base64,");
            if (n > 0) {
              var content = file.split(";base64,")[1];
              var fileCustomName = name.substr(0, name.lastIndexOf("."));
              var fileType = name.split(".").pop();
              var rand_num = randomstring(32);
              if (fileCategory == "galleryvideos") {
                /* 
                For videos we replacing all special characters and spaces with "_" as generating thumbnail do not support special char and spaces in file name
                */
                fileCustomName = fileCustomName.replace(
                  /[&\/\\#,+()$~%.'":*?<>{}\s]/g,
                  "_"
                );
              }
              var filename = `eventify/${eventid}/files/sponsors/${fileCategory}/${fileCustomName}_${rand_num}.${fileType}`;
              var imageJson = {
                resource: [
                  {
                    name: filename,
                    type: "file",
                    is_base64: true,
                    content: content,
                  },
                ],
              };
              /* 
               This Section will uplaod files in aws server but ->
               if "galleryvideos" then it will uplaod to local [file3]
               Vinay changed this to upload video in s3 on - 09-03-2023 
              */
              uploadEncodedFile(
                `${
                  fileCategory === "galleryvideos"
                    ? BASE_IMAGES_URL
                    : BASE_IMAGES_URL
                }?check_exist=false`,
                session,
                imageJson,
                dispatch,
                (data) => {
                  /* 
                  This Section will create thubmnail for a video file from local [file3] if "galleryvideos" 
                  session,filename,foldername,thumbnail name, for {exhibitors/sponsors etc}
                  */

                  // Below code is commented by Vinay on 11-04-2023, as this is not required, we are creating video thumb at time of video upload.
                  // if (fileCategory == "galleryvideos") {
                  //   _callVideoThumbanilReatorFc(
                  //     session,
                  //     `${fileCustomName}_${rand_num}.${fileType}`,
                  //     `eventify/${eventid}/files/sponsors/${fileCategory}`,
                  //     `${fileCustomName}_${rand_num}.${fileType}.jpg`,
                  //     "sponsors/galleryvideos/",
                  //     dispatch,
                  //     (res) => {
                  //       if (res.success) {
                  //       } else {
                  //         callback({ error: 1 });
                  //       }
                  //     }
                  //   );
                  // }

                  uploadFiles[index] = data.name;
                  resolve();
                },
                (error) => {
                  // callback({success:2, message:error});
                }
              );
            } else {
              uploadFiles[index] = file;
              resolve();
            }
          })
        );
      }
    });

    field.fileArray = uploadFiles;
  });

  Promise.all(promiseArray).then(() => {
    callback(otherFilesData);
  });
}

export function _createUpdateSponsor(
  session,
  values,
  sponsor,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor/`;

  if (sponsor.sponsorid) {
    var sponsorid = sponsor.sponsorid;
    values = { ...values, sponsorid };

    delete values["appuser_by_sponsoridfk"];
    delete values["membershiptype_by_categoryid"];

    var sponsorJson = { resource: values, eventid: session.eventid };
    patchRequest(
      url,
      sponsorJson,
      session,
      dispatch,
      (data) => {
        var sponsorid = data.resource[0].sponsorid;
        callback({ success: 1, sponsorid: sponsorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  } else {
    var sponsorJson = { resource: values };
    postRequest(
      url,
      sponsorJson,
      session,
      dispatch,
      (data) => {
        var sponsorid = data.resource[0].sponsorid;
        callback({ success: 1, sponsorid: sponsorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  }
}

function _updteAppuserSponsors(session, values, sponsor, sponsorid, callback) {
  var selectedUsersStr = values.permittedusers;

  // Update with null of the sponsorid, and then update with new sponsorid to the selected appusers
  var filter = `((eventid=${session.eventid}) AND (sponsoridfk=${sponsorid}))`;
  var urlClear = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=${filter}`;
  var bodyNull = { resource: [{ sponsoridfk: null }] };

  return (dispatch) => {
    if (selectedUsersStr != "") {
      var selectedUsers = JSON.parse(selectedUsersStr);
      //Update with sponsorid to all the selected appuser
      var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
      var update = [];
      _.map(selectedUsers, (item) => {
        update.push({
          appuserid: item.appuserid,
          eventid: session.eventid,
          sponsoridfk: sponsorid,
        });
      });
      var body = { resource: update };

      var successCallback = (data) => {
        // dispatch(fetchSponsors(session));
        var returnData = { error: 0, data: data };
        callback(returnData);
      };

      var errorCallback = (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      };

      if (sponsor.sponsorid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            patchRequest(
              url,
              body,
              session,
              dispatch,
              successCallback,
              errorCallback
            );
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        patchRequest(
          url,
          body,
          session,
          dispatch,
          successCallback,
          errorCallback
        );
      }
    } else {
      if (sponsor.sponsorid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            // dispatch(fetchSponsors(session));
            var returnData = { error: 0 };
            callback(returnData);
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        // dispatch(fetchSponsors(session));
        var returnData = { error: 0 };
        callback(returnData);
      }
    }
  };
}

export function updateSponsorFiles(file) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SPONSOR_FILES, payload: file });
  };
}

export function filesChanged(obj) {
  return (dispatch) => {
    dispatch({ type: SPONSOR_FILES_CHANGED, payload: obj });
  };
}

export function openImportSponsorModal(showModal) {
  return { type: IMPORT_SPONSOR_MODAL, payload: showModal };
}

export function importSponsors(session, values, duplicateData, callback) {
  let eventid = session.eventid;
  var url = `${INSTANCE_URL}/api/v2/bulkuploadData`;
  var body = {
    sponsorlist: values,
    eventid: eventid,
    duplicateData: duplicateData,
    source: "sponsore",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchSponsors(session));
        if (response.count > 0) {
          callback({ success: 1, count: response.count });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
export function deleteSponsorAdv(session, sponsorid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (relatedid=${sponsorid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement/?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, error: error });
      }
    );
  };
}

/* This function created for  */
export function _callVideoThumbanilReatorFc(
  session,
  file_name,
  folder_name,
  thumb_name,
  subfolder_name,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    filename: file_name,
    foldername: folder_name,
    thumbname: thumb_name,
    subfoldername: subfolder_name,
    eventid: session.eventid,
    type: "createThumbFromVideo",
  };
  postRequest(
    url,
    postData,
    session,
    dispatch,
    (response) => {
      callback({ success: 1, data: response });
    },
    (error) => {
      callback({ success: 0, data: error });
    }
  );
}

export function fetchDownloadSponsorInfo(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/downloadsponsorinfo`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data.result, count: data.count });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function getSponsorCounts(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    type: "sponsorscount",
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: SPONSOR_COUNTING_NUMBERS,
          payload: data,
        });
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function deleteAllSponsors(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteBulkSponsors(session, appUser, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor`;
  var body = {
    resource: appUser,
  };

  return (dispatch) => {
    deleteBulkRequest(
      url,
      session,
      body,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchSponsorQr(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventqr?service=sponsorqr`;

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);
        callback({ success: 1, data: response });
      },
      (error) => {
        // console.log("error", error);
        callback({ success: 0, message: error });
      }
    );
  };
}
